import React, { useEffect } from "react";
import { queryCache } from "react-query";
import { RouteComponentProps } from "react-router-dom";
import { useDeleteSession } from "../query/users/mutations";
import { reset, track } from "../utils/analytics";
import { useResetWSStore } from "../store";

export const SignOut: React.FC<RouteComponentProps> = ({
  history,
  location
}) => {
  const [deleteSession] = useDeleteSession();
  const resetWSStore = useResetWSStore();

  useEffect(() => {
    const redirectTo = location.hash
      ? location.hash.slice(1)
      : "/member/sign-in";
    const signOut = async () => {
      await deleteSession();
      queryCache.clear();
      window.sessionStorage.removeItem("partner");
      resetWSStore();
      track("Auth", { action: "Log Out" });
      reset();
      history.replace(redirectTo);
    };
    signOut();
  }, [deleteSession, location]);

  return null;
};
